import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import "./DataLabel.scss";

interface IProps {
  label: string;
  value: string | number;
  suffix?: string;
}

export const DataLabel = ({ label, value, suffix = "" }: IProps) => {
  return (
    <Grid item xs={6} className="data-label">
      <Typography variant="overline">{label}</Typography>
      <Typography variant="body1">{`${value}${suffix}`}</Typography>
    </Grid>
  );
};
